module.exports = __webpack_public_path__ + "img/icon16.5fe9f308.png";